const CHILD_SELECTOR = '[dh-receive-historiescroll-attributes]'
const STATE_ATTR = 'data-state'
const VIEWPORT_POSITION_ATTR = 'viewport-position'
const VIEWPORT_POSITION_DATA_ATTR = 'data-viewport-position'

const STOPS_ATTR = 'stops'
const TARGET_STOP_ATTR = 'target-stop'

export function setAttribute(el, name, nextValue) {
  if (!el) {
    return
  }

  if (typeof nextValue === 'undefined' || nextValue === null) {
    el.removeAttribute(name)
  } else {
    el.setAttribute(name, nextValue)
  }
}

/*
 * Copies down the 'data-state' attribute to child.
 * Detects and sets 'data-viewport-position' on child.
 * */
export default class Spesialmodul extends HTMLElement {
  static get observedAttributes() {
    return [STATE_ATTR, VIEWPORT_POSITION_ATTR, STOPS_ATTR, TARGET_STOP_ATTR]
  }

  connectedCallback() {}

  disconnectedCallback() {}

  attributeChangedCallback(name, prev, next) {
    if (prev === next) {
      return
    }
    this._updateChildElements()
  }

  _updateChildElements() {
    const state = this.state
    const viewportPosition = this.viewportPosition
    const spesialmoduler = this.spesialmoduler
    const stops = this.stops
    const targetStop = this.targetStop
    for (const spesialmodul of spesialmoduler) {
      setAttribute(spesialmodul, STATE_ATTR, state)
      setAttribute(spesialmodul, VIEWPORT_POSITION_DATA_ATTR, viewportPosition)
      if (stops && stops.length) {
        setAttribute(spesialmodul, STOPS_ATTR, stops)
        setAttribute(spesialmodul, TARGET_STOP_ATTR, targetStop)
      }
    }
  }

  get spesialmoduler() {
    return Array.from(this.querySelectorAll(CHILD_SELECTOR))
  }

  get viewportPosition() {
    return this.getAttribute(VIEWPORT_POSITION_ATTR)
  }

  set viewportPosition(value) {
    setAttribute(this, VIEWPORT_POSITION_ATTR, value)
  }

  get state() {
    return this.getAttribute(STATE_ATTR)
  }

  set state(value) {
    setAttribute(this, STATE_ATTR, value)
  }

  get stops() {
    return this.getAttribute(STOPS_ATTR)
  }

  set stops(val) {
    this.setAttribute(STOPS_ATTR, val)
  }

  get targetStop() {
    return Number(this.getAttribute(TARGET_STOP_ATTR))
  }

  set targetStop(val) {
    this.setAttribute(TARGET_STOP_ATTR, val)
  }
}
